// pages/About.jsx
import React from 'react';

import Samir1 from '../images/samir1.jpg';
import Samir2 from '../images/samir2.jpg';
import Samir3 from '../images/samir3.jpg';

const About = () => {
    return (
        <div className="container">
            <h2 className="section-title">About Samir Dutta</h2>

            {/* Artist Bio Section */}
            <div className="about-section">
                {/* <div className="about-image slide-up">
                    <img src={samirdutta} alt="Samir Dutta Portrait" />
                </div> */}
                <div className="about-content slide-up">
                    <h2>The Artist's Journey</h2>
                    <div className="bio-text">
                        <p>
                            Eminent Artist Samir Dutta hailing from North Indian ambience and trained from rich culture heritage of Chhattisgarh uses Folk backdrop as a sophisticated artistic tool in his art. In this way he is a pioneer in inducing modernism in elements of folk tradition. Samir not only derives artistic inspiration from folk, but also plunges deep inside of the inner world.
                        </p>
                        <p>
                            After this plunge he engulfs modernism at many strata of folk tradition. In a way he, by placing folk practice on modern society's mirror, makes it a part of chemistry. In this chemistry he weighs tradition from many angles and place it before modern world. In this process the creativity generated weaves a different web of Samir's own philosophy of life. This form has many facets. By looking through these layers we can understand artistic nuances of Samir and Samir himself.
                        </p>
                    </div>
                </div>
            </div>

            {/* Biography Section - Extended */}
            <div className="biography-full" style={{ position: 'relative', padding: '2rem', margin: '3rem 0', backgroundColor: 'rgba(227, 180, 72, 0.05)', borderRadius: '8px' }}>
                <div className="bengali-pattern pattern-top"></div>

                <h3 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem', borderBottom: '2px solid var(--secondary-color)', paddingBottom: '0.5rem' }}>Artistic Narrative</h3>

                <p>
                    Most appealing quality of Samir's paintings is their narratives base. It looks at through he is telling a story in each of his painting. Some time this tale is inherently interspersed between his painting and sometimes it hangs behind. It is mythological and modern as well. It innate base lies some where in the folk. It seems that Samir is searching for an extrasensory world.
                </p>

                <p>
                    Although Samir is an atheist and therefore presence of deities in his paintings is established not by their divinity but by being earthly. Samir very skillfully draws mobile and computer along with mythological characters, whether it is owl, elephant, ducks, lord Radha & Krishna or imaginary Godly figures. Samir has also infused modernity in the attire of these Gods & Animals or Birds. Hence by using material resources Samir at one hand depicts effects of modern science, on the other side he also brings these divine characters from extraterrestrial to material world. In his paintings Samir has shown human faces and birds bodies. His efforts indicates that every human being hides a bird instinct behind him. Besides this bird kingdom, aquatic fish species had also been given prominence.
                </p>

                <h3 style={{ color: 'var(--primary-color)', margin: '2rem 0 1.5rem', borderBottom: '2px solid var(--secondary-color)', paddingBottom: '0.5rem' }}>Philosophical Approach</h3>

                <p>
                    Samir gives an impression while depicting Ajanta themes that this is a world of mortals. Thus he looks siding along with philosophy of mortality. His art shows that frozen world of dead people wants to make us like them. This is the life of inanimate. Samir finds that philosophy holds science, not the other way around. This applies to his world of paintings, whether it is world of living or dead, Samir very skillfully depicts pathos of life philosophy and not the scientific achievements.
                </p>

                <h3 style={{ color: 'var(--primary-color)', margin: '2rem 0 1.5rem', borderBottom: '2px solid var(--secondary-color)', paddingBottom: '0.5rem' }}>Artistic Medium & Technique</h3>

                <p>
                    On the level of medium, Samir has worked with Acrylic Colour, Water Colour, Oil Colour, Tempera, Pencil & Ink etc. At the level of composition his drawings shows such a wonderful balance of lines and points and manage to strike a chord with subject, that white surface of canvas turns out to be an effective background. His technique has this quality of expressing so much through unicolour background.
                </p>

                <p>
                    While design of this characters attire shows clear impact of, Chhattisgarh, Madhubani's life & Culture. On the other hand their hairstyle encompasses Ajanta theme shadows. He draws sketches of tree with Madhubani school effect. Government College Art & Craft, Kolkata, education had lent him special ability to draw various forms. In this manner Samir's art creates modern world folk in totality of various tools of art-be it colour, line, point, subject or composition.
                </p>

                <div className="bengali-pattern pattern-bottom"></div>
            </div>

            <div className="section">
                {/* Artist Images Section */}
                <h3 style={{
                    fontSize: '1.8rem',
                    marginBottom: '1.5rem',
                    position: 'relative',
                    color: 'var(--primary-color)',
                    textAlign: 'center'
                }}>
                    The Artist at Work
                </h3>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                    gap: '1rem',
                    marginBottom: '3rem'
                }}>
                    <div className="artist-image slide-up" style={{
                        borderRadius: '8px',
                        overflow: 'hidden',
                        height: '280px'
                    }}>
                        <img
                            src={Samir1}
                            alt="Samir Dutta in his studio"
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                    </div>
                    <div className="artist-image slide-up" style={{
                        borderRadius: '8px',
                        overflow: 'hidden',
                        height: '280px'
                    }}>
                        <img
                            src={Samir3}
                            alt="Samir Dutta in his studio"
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                    </div>
                    <div className="artist-image slide-up" style={{
                        borderRadius: '8px',
                        overflow: 'hidden',
                        height: '280px'
                    }}>
                        <img
                            src={Samir2}
                            alt="Samir Dutta in his studio"
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                    </div>
                </div>
            </div>

            {/* Educational Background */}
            <div className="section">
                <h3 style={{
                    fontSize: '1.8rem',
                    marginBottom: '1.5rem',
                    position: 'relative',
                    color: 'var(--primary-color)',
                    textAlign: 'center'
                }}>
                    Educational Background
                </h3>

                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '2rem',
                    justifyContent: 'center'
                }}>
                    <div style={{
                        flex: '1',
                        minWidth: '250px',
                        backgroundColor: 'white',
                        padding: '1.5rem',
                        borderRadius: '8px',
                        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)',
                        position: 'relative',
                        overflow: 'hidden'
                    }}>
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '5px',
                            height: '100%',
                            backgroundColor: 'var(--primary-color)'
                        }}></div>
                        <h4 style={{ color: 'var(--primary-color)' }}>Master of Fine Arts (MFA)</h4>
                        <p>Government College of Art & Craft, Kolkata</p>
                        <p style={{ color: 'var(--accent-color)', marginTop: '0.5rem' }}>2003</p>
                    </div>

                    <div style={{
                        flex: '1',
                        minWidth: '250px',
                        backgroundColor: 'white',
                        padding: '1.5rem',
                        borderRadius: '8px',
                        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)',
                        position: 'relative',
                        overflow: 'hidden'
                    }}>
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '5px',
                            height: '100%',
                            backgroundColor: 'var(--secondary-color)'
                        }}></div>
                        <h4 style={{ color: 'var(--secondary-color)' }}>Bachelor of Fine Arts (BFA)</h4>
                        <p>Government College of Art & Craft, Kolkata</p>
                        <p style={{ color: 'var(--accent-color)', marginTop: '0.5rem' }}>2000</p>
                    </div>

                    <div style={{
                        flex: '1',
                        minWidth: '250px',
                        backgroundColor: 'white',
                        padding: '1.5rem',
                        borderRadius: '8px',
                        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)',
                        position: 'relative',
                        overflow: 'hidden'
                    }}>
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '5px',
                            height: '100%',
                            backgroundColor: 'var(--accent-color)'
                        }}></div>
                        <h4 style={{ color: 'var(--accent-color)' }}>Madhyamik</h4>
                        <p>Academic Qualification</p>
                        <p style={{ color: 'var(--accent-color)', marginTop: '0.5rem' }}>1995</p>
                    </div>
                </div>
            </div>

            {/* Highlights Section */}
            <div className="bio-highlights">
                <div className="highlight-item fade-in">
                    <i className="fas fa-palette"></i>
                    <h3>Artistic Approach</h3>
                    <p>
                        Creating a unique bridge between folk traditions and contemporary art, Samir's approach weaves narratives that speak to both the past and present, using traditional techniques with modern sensibilities.
                    </p>
                </div>
                <div className="highlight-item fade-in">
                    <i className="fas fa-globe-asia"></i>
                    <h3>Cultural Influences</h3>
                    <p>
                        Drawing from the rich tapestry of North Indian, Bengali, and Chhattisgarh folk traditions, alongside Madhubani patterns and Ajanta motifs, creating a unique cultural synthesis.
                    </p>
                </div>
                <div className="highlight-item fade-in">
                    <i className="fas fa-book-open"></i>
                    <h3>Narrative Style</h3>
                    <p>
                        Each artwork tells a story that bridges mythology with modernity, creating dialogues between traditional characters and contemporary elements that invite viewers to explore deeper meanings.
                    </p>
                </div>
            </div>

            {/* Teaching Experience */}
            <div className="section" style={{ backgroundColor: 'rgba(51, 92, 103, 0.05)', padding: '3rem', borderRadius: '8px' }}>
                <h3 style={{
                    fontSize: '1.8rem',
                    marginBottom: '1.5rem',
                    color: 'var(--primary-color)',
                    textAlign: 'center'
                }}>
                    Teaching & Professional Experience
                </h3>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                    gap: '1.5rem'
                }}>
                    <div className="experience-item slide-up" style={{
                        backgroundColor: 'white',
                        padding: '1.5rem',
                        borderRadius: '8px',
                        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)'
                    }}>
                        <div style={{ marginBottom: '1rem', color: 'var(--accent-color)' }}>
                            <i className="fas fa-chalkboard-teacher" style={{ fontSize: '2rem' }}></i>
                        </div>
                        <h4>Senior Art Teacher</h4>
                        <p>Birla Academy Art and Culture, Kolkata</p>
                        <p style={{ marginTop: '0.5rem', color: 'var(--accent-color)', fontSize: '0.9rem' }}>2022-2024</p>
                    </div>

                    <div className="experience-item slide-up" style={{
                        backgroundColor: 'white',
                        padding: '1.5rem',
                        borderRadius: '8px',
                        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)'
                    }}>
                        <div style={{ marginBottom: '1rem', color: 'var(--accent-color)' }}>
                            <i className="fas fa-child" style={{ fontSize: '2rem' }}></i>
                        </div>
                        <h4>Art Teacher</h4>
                        <p>Nehru Children Museum, Kolkata</p>
                        <p style={{ marginTop: '0.5rem', color: 'var(--accent-color)', fontSize: '0.9rem' }}>2010-2022</p>
                    </div>

                    <div className="experience-item slide-up" style={{
                        backgroundColor: 'white',
                        padding: '1.5rem',
                        borderRadius: '8px',
                        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)'
                    }}>
                        <div style={{ marginBottom: '1rem', color: 'var(--accent-color)' }}>
                            <i className="fas fa-film" style={{ fontSize: '2rem' }}></i>
                        </div>
                        <h4>Art Director</h4>
                        <p>Tollywood, Kolkata</p>
                        <p style={{ marginTop: '0.5rem', color: 'var(--accent-color)', fontSize: '0.9rem' }}>Film Industry Experience</p>
                    </div>
                </div>
            </div>

            {/* Skills Section */}
            {/* <div className="skills-section">
                <h2 className="section-title">Artistic Expertise</h2>
                <div className="skills-grid">
                    {skills.map((skill, index) => (
                        <div key={index} className="skill-item fade-in">
                            <h4>{skill.name}</h4>
                            <div className="skill-progress">
                                <div className="skill-progress-bar" style={{ width: `${skill.level}%` }}></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div> */}

            {/* Artist Statement */}
            <div className="section">
                <h2 className="section-title">Artist Statement</h2>
                <div className="slide-up" style={{
                    maxWidth: '800px',
                    margin: '0 auto',
                    textAlign: 'center',
                    padding: '2rem',
                    background: 'rgba(227, 180, 72, 0.1)',
                    borderRadius: '8px',
                    position: 'relative',
                    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)'
                }}>
                    <div style={{
                        position: 'absolute',
                        top: '10px',
                        left: '10px',
                        width: '30px',
                        height: '30px',
                        backgroundImage: 'url("/images/bengali-ornament1.svg")',
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                        opacity: 0.5
                    }}></div>
                    <p style={{ fontSize: '1.2rem', fontStyle: 'italic', lineHeight: 1.8 }}>
                        "I seek to create a dialogue between our rich folk traditions and the modern world we inhabit. My work is a continuous exploration of how mythological narratives and characters can speak to contemporary concerns, creating a bridge between past wisdom and present reality. Through my art, I aim to show that philosophy guides science, that stories transcend time, and that the material and spiritual worlds are not as separate as they might appear."
                    </p>
                    <p style={{ marginTop: '1rem', fontWeight: 'bold', color: 'var(--primary-color)' }}>
                        — Samir Dutta
                    </p>
                    <div style={{
                        position: 'absolute',
                        bottom: '10px',
                        right: '10px',
                        width: '30px',
                        height: '30px',
                        backgroundImage: 'url("/images/bengali-ornament2.svg")',
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                        opacity: 0.5
                    }}></div>
                </div>
            </div>
        </div>
    );
};

export default About;